import React from 'react';
import styles from "./styles.module.scss";
import MultiSelectCellComponentWithSearch from '../../../common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import AButton from '../../../common/form-fields-mui/AButton';
import { getFormatedDate } from '../../../unAssigned/concessionApproval/common';


const ConfigSummaryCard = ({
    config,
    deleteConfigHandler,
    editConfigHandler,
    isUpdatePermission,
    isDeletePermission,
}) => {

    const { businessArea, l1Roles, l2Roles, id, updatedOn } = config;


    return (
        <div className={styles["config-summary-card"]}>

            <div className={styles["card-heading"]}>

                <div className='d-flex justify-content-center align-items-center'>
                    <MultiSelectCellComponentWithSearch title={"Business Area"} data={businessArea} />
                    <div>&nbsp; | Cash, EPMR, Cheque/DD</div>
                </div>

                <div>
                    <AButton
                        variant="link"
                        updatedStyle={{ color: '#E7685A' }}
                        onClick={() => deleteConfigHandler(id)}
                        disabled={!isDeletePermission}
                    >Delete
                    </AButton>

                    <AButton
                        variant="link"
                        onClick={() => editConfigHandler(config)}
                        disabled={!isUpdatePermission}
                    >
                        Edit
                    </AButton>
                </div>

            </div>

            <div className={styles['label']}>Last updated on : {getFormatedDate(updatedOn, true)}</div>

            <div className={styles['roles-info-container']}>

                <div>
                    <div className={styles['label']}>
                        L1 Roles
                    </div>
                    <MultiSelectCellComponentWithSearch data={l1Roles} title={"L1 Roles"} />
                </div>

                <div>
                    <div className={styles['label']}>
                        L2 Roles
                    </div>
                    <MultiSelectCellComponentWithSearch data={l2Roles} title={"L2 Roles"} />
                </div>

            </div>



        </div>
    );
}

export default ConfigSummaryCard;